<template >
  <div >
    <v-row >
      <v-col class="py-2">
        <FlyoutMenuHead :selectedItem="selectedItem" route="addLocation"/>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row class="mt-4">
      <v-col md="12" class="d-flex align-center justify-space-between pt-4">
        <span class="subtitle text-secondary">{{ $t('assets.locations.locationsInfoEdit.title') }}</span>
      </v-col>
    </v-row>
    <v-form
    class="overflow-y-auto scroll-right-md-y scroll-right-lg-y"
    v-model="isFormValid" 
    @submit.prevent="addLocation()">
      <v-row>
        <v-col md="8" class="d-flex align-center justify-space-between pb-0">
          <v-text-field
            class="pt-0 mb-0"
              v-model="location.name"
              height="40"
              :maxlength="256"
              :counter="256"
              placeholder="Friendly name for your location"
              :rules="[rules.required]"
              dense
              outlined
          ><template #label>
              <span class="pl-1 pr-1">{{ $t('assets.locations.locationsInfoEdit.locationName') }}</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="8" class="d-flex align-center justify-space-between">
          <v-text-field
              class="pt-0 mb-0"
              v-model="location.display_id"
              height="40"
              :maxlength="256"
              :counter="256"
              placeholder="Display id for your location"
              dense
              outlined
              :error-messages="fieldErrors.display_id || []"
              @input="changeInput('display_id')"
              @change="changeInput('display_id')"
          > <template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsGeneral.locationDisplayId')}}</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="8" class="d-flex align-center justify-space-between">
          <v-select
              class="mt-n3"
              :append-icon="$vuetify.icons.values.chevronDown"
              :items="location_types"
              v-model="location.location_type_uuid"
              outlined
              :rules="[rules.required]"
              dense
              height="40"
              item-text="name"
              item-value="uuid"
            >
          <template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsGeneral.type')}}</span>
            </template>
          </v-select>
        </v-col>
      </v-row>
      <v-row class="px-1">
        <v-col md="4" class="d-flex align-center justify-space-between pl-0">
          <v-select
              :append-icon="$vuetify.icons.values.chevronDown"
              :items="countries.countries"
              v-model="location.country_code"
              class="ml-2 mt-n3"
              placeholder="Country"
              :rules="[rules.required]"
              outlined
              dense
              height="40"
              item-text="name"
              item-value="code"
              @change="updateSearch()"
          >
          <template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsGeneral.country')}}</span>
            </template>
          </v-select>
        </v-col>
        <v-col md="4" class="d-flex align-center justify-space-between pr-0">
          <v-text-field
              v-model="location.city"
              class="mr-2 mt-n3"
              :rules="[rules.required]"
              height="40"
              dense
              outlined
              @change="updateSearch()"
              placeholder="City"
              label=""
          ><template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsGeneral.city')}}</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-1">
        <v-col md="4" class="d-flex align-center justify-space-between pl-0">
          <v-text-field
              v-model="location.address"
              class="ml-2 mt-n3"
              :rules="[rules.required]"
              height="40"
              dense
              outlined
              @change="updateSearch()"
              placeholder="Address"
              label=""
          > <template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsGeneral.address')}}</span>
            </template>
          </v-text-field>
        </v-col>
        <v-col md="4" class="d-flex align-center justify-space-between pr-0">
          <v-text-field
              v-model="location.zip_code"
              class="mr-2 mt-n3"
              height="40"
              :rules="[rules.required]"
              dense
              outlined
              @change="updateSearch()"
              placeholder="Zip Code"
              label=""
          ><template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsGeneral.zipCode')}}</span>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row class="px-1">
        <v-col md="4" class="d-flex align-center justify-space-between pl-0">
          <v-select
          :append-icon="$vuetify.icons.values.chevronDown"
          :items="timezones"
          v-model="location.timezone"
          class="ml-2 mt-n3"
          placeholder="Timezone"
          :rules="
            this.location.location_type_uuid
              ? [rules.required]
              : []
          "
          outlined
          dense
          height="40"
          item-text="name"
          item-value="code"
          @change="changeInput"
        >
        <template #label>
              <span class="pl-1 pr-1">{{$t('assets.locations.locationsInfoEdit.timezone')}}</span>
        </template>
        </v-select>
        </v-col>
      </v-row>
      <v-row class="px-1">
        <v-col md="8" class="px-2 py-1">
          <GmapMap
              ref="map"
              :options="map.options"
              :center="map.center"
              :zoom="map.zoom"
              style="width: 100%; height: 278px; border: solid 1px #dedede; border-radius: 4px;"
          >
            <GmapMarker
                :position="map.pin.position"
                :clickable="true"
                :draggable="true"
                @click="map.center = map.pin.position"
                @dragend="updateMarker"
            />
          </GmapMap>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="8" class="pt-9">
          <v-textarea
              v-model="location.description"
              outlined
              placeholder="Description"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-row class="overflow-y-auto mb-12">
        <v-col md="8" class="d-flex align-center justify-space-between">
          <v-autocomplete
              v-model="location.tag_uuids"
              :items="tags"
              placeholder="Enter tags for your new location"
              dense
              outlined
              height="40px"
              :append-icon="icons.mdiMenuDown"
              @update:search-input="onTagChange"
              :counter="20"
              item-text="name"
              item-value="uuid"
              @keydown.enter="onAddTag"
              :search-input.sync="tagToAdd"
              @input="tagToAdd = null"
              chips
              hint="asd"
              persistent-hint
              maxlength="20"
              deletable-chips
              multiple>
            <template v-slot:message>
              <div class="mt-2 ml-n3 mb-10">
                <span>{{ $t('assets.locations.locationsInfoEdit.tagsSubtitle') }}</span>
              </div>
            </template>
            <template v-slot:label>
              <span class="pl-1 pr-1">{{ $t('assets.locations.locationsInfoEdit.tags') }}</span>
            </template>
            <template v-slot:item="data">
              <v-list-item-content>
                <v-list-item-title class="d-flex align-start justify-space-between">
                  <span class="font-weight-regular">{{ data.item.name }}</span>
                  <span class="font-weight-light">{{ data.item['total_number'] || 0 }} devices and locations</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
            <template v-slot:no-data >
              <v-list-item-content>
                <v-list-item-title class="d-flex align-start justify-space-between px-4 ">
                  <span class="font-weight-regular caption mb-8">{{ tagToAdd }}</span>
                  <span class="font-weight-light caption">New</span>
                </v-list-item-title>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row class="mb-12">
        <!-- did it like this to have more readible code and,
          one source of truth for location data object and error handling-->
        <v-col md="8" class="mb-16">
          <div class="pb-6">
            <span>{{ $t('assets.tabs.custom_fields') }}</span>
          </div>
          <v-row>
            <!-- Custom Field 1 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_1_enabled"
            >
              <v-text-field
                v-model="location.location_custom_1"
                :label="location.location_custom_1_alias"
                @input="changeInput('location_custom_1')"
                :error-messages="fieldErrors.location_custom_1 || []"
                outlined
                dense
              ></v-text-field>

            </v-col>

            <!-- Custom Field 2 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_2_enabled"
            >
              <v-text-field
                v-model="location.location_custom_2"
                :label="location.location_custom_2_alias"
                @input="changeInput('location_custom_2')"
                :error-messages="fieldErrors.location_custom_2 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <!-- Custom Field 3 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_3_enabled">
              <v-text-field
                v-model="location.location_custom_3"
                :label="location.location_custom_3_alias"
                @input="changeInput('location_custom_3')"
                :error-messages="fieldErrors.location_custom_3 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <!-- Custom Field 4 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_4_enabled"
            >
              <v-text-field
                v-model="location.location_custom_4"
                :label="location.location_custom_4_alias"
                @input="changeInput('location_custom_4')"
                :error-messages="fieldErrors.location_custom_4 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <!-- Custom Field 5 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_5_enabled"
            >
              <v-text-field
                v-model="location.location_custom_5"
                :label="location.location_custom_5_alias"
                @input="changeInput('location_custom_5')"
                :error-messages="fieldErrors.location_custom_5 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <!-- Custom Field 6 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_6_enabled"
            >
              <v-text-field
                v-model="location.location_custom_6"
                :label="location.location_custom_6_alias"
                @input="changeInput('location_custom_6')"
                :error-messages="fieldErrors.location_custom_6 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <!-- Custom Field 7 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_7_enabled"
            >
              <v-text-field
                v-model="location.location_custom_7"
                :label="location.location_custom_7_alias"
                @input="changeInput('location_custom_7', $event)"
                :error-messages="fieldErrors.location_custom_7 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
            <!-- Custom Field 8 -->
            <v-col
              cols="12"
              class="py-1"
              v-if="location.location_custom_8_enabled"
            >
              <v-text-field
                v-model="location.location_custom_8"
                :label="location.location_custom_8_alias"
                @input="changeInput('location_custom_8')"
                :error-messages="fieldErrors.location_custom_8 || []"
                outlined
                dense
              ></v-text-field>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row  class="text-right bottom-navigation-edit py-4 px-2" v-bind:style= "[this.$vuetify.theme.dark ? {'background-color': '#1E1E1E'} : {'background-color':'#ffffff'}]" >
        <v-col >
          <v-btn
              width="120"
              class="mr-2 font-weight-regular letter-spacing-normal text-capitalize"
              depressed
              text
              @click="closeForm()"
          >{{ $t("common.cancelBtn") }}
          </v-btn>
          <v-btn
              width="120"
              id="btn-blue-disabled"
              class="font-weight-normal letter-spacing-normal text-capitalize"
              color="primary"
              depressed
              type="submit"
              :disabled="!isFormValid"
          >{{ $t("assets.devices.addRunner.addBtn") }}
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import LocationsApi from "../../services/api/Locations";
import {gmapApi} from "vue2-google-maps";
import FlyoutMenuHead from "../FlyoutMenuHead";
import { mapGetters, mapActions } from "vuex";
import { mdiMenuDown } from '@mdi/js';
export default {
  components: {
    FlyoutMenuHead,
  },
  computed: {
    ...mapGetters({
      "tags": "tags/tags",
      
    }),
    google: gmapApi,
  },
  data() {
    return {
      icons: {
        mdiMenuDown: mdiMenuDown
      },
      tagToAdd: "",
      selectedItem: {
        name: "Add Location",
        subtitle:
            "Locations help you organize devices so you can easily navigate them throughout the interface.",
      },
      map: {
        pin: {
          position: {
            lat: 0,
            lng: 0,
          },
        },
        center: {
          lat: 43.3438,
          lng: 17.8078,
        },
        zoom: 7,
        options: {
          fullscreenControl: false,
          streetViewControl: false,
          mapTypeControl: false,
          scaleControl: false,
          zoomControl: true,
          styles: [
            {
              featureType: "water",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  color: "#b5cbe4",
                },
              ],
            },
            {
              featureType: "landscape",
              stylers: [
                {
                  color: "#efefef",
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  color: "#83a5b0",
                },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [
                {
                  color: "#bdcdd3",
                },
              ],
            },
            {
              featureType: "road.local",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#e3eed3",
                },
              ],
            },
            {
              featureType: "administrative",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  lightness: 33,
                },
              ],
            },
            {
              featureType: "road",
            },
            {
              featureType: "poi.park",
              elementType: "labels",
              stylers: [
                {
                  visibility: "on",
                },
                {
                  lightness: 20,
                },
              ],
            },
            {},
            {
              featureType: "road",
              stylers: [
                {
                  lightness: 20,
                },
              ],
            },
          ],
        },
      },
      location: {},
      timer: null,
      isFormValid: false,
      location_rules: {},
      location_types: [],
      countries: [],
      timezones: [],
      rules: {
        required: (value) => !!value || "Required.",
      },
      fieldErrors: {
        name: [],
        display_id: [],
        country_code: [],
        city: [],
        address: [],
        zip_code: [],
        timezone: [],
        description: [],
        tag_uuids: [],
        location_custom_1: [],
        location_custom_2: [],
        location_custom_3: [],
        location_custom_4: [],
        location_custom_5: [],
        location_custom_6: [],
        location_custom_7: [],
        location_custom_8: [],
      },
    };
  },
  mounted() {
    this.getDeviceLocation();
    this.getLocationTypes();
    this.getCountries();
    this.getTags("location");
    this.getTimezones(); 
  },
  methods: {
    ...mapActions({
      "getTags": "tags/getTags", 
      "addTag": "tags/addTag", 
      "customFields": "locations/getSpaceCustomFields" 
    }),
    updateSearch() {
    clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.findPlaces();
      }, 400);
    },
    closeForm(){
      this.$router.go(-1)
    },
    findPlaces() {
      let query = "";
      if (this.location.country_code) {
        query += `${this.location.country_code}`;
      }
      if (this.location.city) {
        query += `+${this.location.city.split(" ").join("+")}`;
      }
      if (this.location.address) {
        query += `+${this.location.address.split(" ").join("+")}`;
      }
      let that = this;
      this.$refs.map.$mapPromise.then((map) => {
        let service = new this.google.maps.places.PlacesService(map);
        service.findPlaceFromQuery(
            {
              query: query,
              fields: ["name", "geometry"],
            },
            function (results) {
              if (results && results.length) {
                that.updateMarkerLocation(
                    results[0].geometry.location.lat(),
                    results[0].geometry.location.lng()
                );
              }
            }
        );
      });
    },
    getDeviceLocation() {
      this.$getLocation({
        enableHighAccuracy: true,
        timeout: Infinity,
        maximumAge: 0,
      }).then((coordinates) => {
            this.map.pin.position = coordinates;
        }).catch((err) => {
          console.log(err);
      });
    },
    validateCustomFields() {
      let hasErrors = false;

      for (let i = 1; i <= 8; i++) {
        const enabled = this.location[`location_custom_${i}_enabled`];
        const required = this.location[`location_custom_${i}_required`];
        const alias = this.location[`location_custom_${i}_alias`] || `Custom Field ${i}`;
        const value = this.location[`location_custom_${i}`];

        const isBlank = value === null || value === undefined || String(value).trim() === "";

        if (enabled && required && isBlank) {
          const unique = this.location[`location_custom_${i}_unique`];
          this.$set(this.fieldErrors, `location_custom_${i}`, [
            unique ? `${alias} is required and must be unique` : `${alias} cannot be blank`,
          ]);
          hasErrors = true;
        } else {
          this.$set(this.fieldErrors, `location_custom_${i}`, []);
        }
      }

      return !hasErrors;
    },

    onAddTag() {
      this.addTag(this.tagToAdd);
    },
    onTagChange(tag) {
      this.tagToAdd = tag;
    },
    updateMarkerLocation(lat, lng) {
      this.map.pin.position.lat = lat;
      this.map.pin.position.lng = lng;
    },
    updateMarker(e) {
      this.map.pin.position.lat = e.latLng.lat();
      this.map.pin.position.lng = e.latLng.lng();
    },
    clearFieldErrors() {
      Object.keys(this.fieldErrors).forEach((field) => {
        this.$set(this.fieldErrors, field, []);
      });
    },
    addLocation() {
      this.loading = true;

      // Clear previous errors reactively
     this.clearFieldErrors();
      // Validate custom fields before API call
      if (!this.validateCustomFields()) {
        this.loading = false;
        return;
      }

      // Prepare the payload without `_alias` and `_enabled`
      const customData = {};
      for (let i = 1; i <= 8; i++) {
        if (this.location[`location_custom_${i}_enabled`]) {
          customData[`location_custom_${i}`] = this.location[`location_custom_${i}`];
        }
      }

      const payload = {
        name: this.location.name,
        description: this.location.description,
        display_id: this.location.display_id,
        zip_code: this.location.zip_code,
        country_code: this.location.country_code,
        city: this.location.city,
        address: this.location.address,
        latitude: this.map.pin.position.lat,
        longitude: this.map.pin.position.lng,
        tag_uuids: this.location.tag_uuids,
        timezone: this.location.timezone,
        location_type_uuid: this.location.location_type_uuid,
        ...customData,
      };

      LocationsApi.add(this.$route.params.uuid, payload)
        .then((response) => {
          this.$store.commit('locations/PUSH_LOCATION', response.data);
          this.$router.go(-1);
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;

          const response = error.response;

          if (!response) {
            this.showLocationError();
            return;
          }

          if (response.status === 400) {
            const errData = response.data;

            if (errData.errors) {
              Object.keys(errData.errors).forEach(field => {
                const messages = Array.isArray(errData.errors[field])
                  ? errData.errors[field]
                  : [String(errData.errors[field])];

                this.$set(this.fieldErrors, field, messages);
              });
            } else if (errData.message) {
              this.$set(this.fieldErrors, 'general', [errData.message]);
            }

            return;
          }

          if (response.status === 409) {
            const message = response.data?.message;

            if (message) {
              const customFieldMatch = message.match(/location_custom_\d+/);

              if (customFieldMatch) {
                this.$set(
                  this.fieldErrors,
                  customFieldMatch[0],
                  [message]
                );
                return;
              }

              if (message.toLowerCase().includes('display_id')) {
                this.$set(
                  this.fieldErrors,
                  'display_id',
                  [message]
                );
                return;
              }
            }
          }

          this.showLocationError();
        });
    },
    showLocationError() {
      this.$store.commit("updateAlert", {
        type: "error",
        shown: true,
        message: "An unexpected error occurred",
      });
    },
    getLocationTypes() {
      LocationsApi.getTypes()
          .then((response) => {
            this.location_types = response.data.location_types;
            this.location_types.forEach((type) => {
              switch (type.name) {
                case "Office Building":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Single Office":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Shop":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Factory":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Warehouse":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Home":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  break;
                case "Apartment":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  break;
                case "Event Venue":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Mall":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  this.location_rules[type.uuid].address = [this.rules.required];
                  this.location_rules[type.uuid].zip_code = [this.rules.required];
                  break;
                case "Land":
                  this.location_rules[type.uuid] = {};
                  this.location_rules[type.uuid].country = [this.rules.required];
                  this.location_rules[type.uuid].city = [this.rules.required];
                  break;
                case "Mobile":
                  this.location_rules[type.uuid] = {};
                  return;
                case "Other":
                  this.location_rules[type.uuid] = {};
                  break;
                default:
                  return;
              }
            });
          })
          .catch((err) => {
            this.$store.commit("updateAlert", {
              type: "error",
              shown: true,
              message: `Failed to get location types. Check console.`,
            });
            console.log(err);
          });
    },
    getCountries() {
      LocationsApi.getCountries()
          .then((response) => {
            this.countries = response.data;
          })
          .catch((err) => {
            this.$store.commit("updateAlert", {
              type: "error",
              shown: true,
              message: `Failed to get countries. Check console.`,
            });
            console.log(err);
          });
        },
    getTimezones() {
      this.getSpaceData()
        .then(({ timezone, customFields }) => {
          if (!timezone) {
            console.error("Failed to get space timezone.");
            return;
          }
          // Populate timezone list
          const timeZoneIdentifiers = Intl.supportedValuesOf("timeZone");

          let tmpTimezones = timeZoneIdentifiers.map((tz) => ({
            name: tz,
            code: tz,
          }));

          // Mark the space timezone with a custom label
          tmpTimezones = tmpTimezones.map((tz) => {
            if (tz.name === timezone) {
              return {
                ...tz,
                name: this.$t("assets.locations.locationsGeneral.globalTimezone"),
              };
            }
            return tz;
          });

          // Move the space timezone to the top
          const spaceTimezone = tmpTimezones.find(
            (tz) => tz.name === this.$t("assets.locations.locationsGeneral.globalTimezone")
          );

          tmpTimezones = tmpTimezones.filter(
            (tz) =>
              tz.name !==
              this.$t("assets.locations.locationsGeneral.globalTimezone")
          );

          this.timezones = spaceTimezone
            ? [spaceTimezone, ...tmpTimezones]
            : tmpTimezones;

          // Build the location object dynamically
          const updatedLocation = { ...this.location, timezone };

          for (let i = 1; i <= 8; i++) {
            const base = `location_custom_${i}`;
            updatedLocation[base] = '';
            updatedLocation[`${base}_alias`] = customFields[`${base}_alias`] || `Custom ${i}`;
            updatedLocation[`${base}_enabled`] = !!customFields[`${base}_enabled`];
            updatedLocation[`${base}_required`] = !!customFields[`${base}_required`];
          }

          if (!updatedLocation.description) updatedLocation.description = "";
          if (!updatedLocation.tag_uuids) updatedLocation.tag_uuids = [];

          this.location = updatedLocation;


        })
        .catch((err) => {
          console.error("Error fetching timezones:", err);
        });
    },
  changeInput(field) {
    if (this.fieldErrors[field]) {
      this.$set(this.fieldErrors, field, []);
    }
  },
  getSpaceData() {
  return new Promise((resolve, reject) => {
    LocationsApi.getSpace()
      .then((response) => {
        const spaceData = response.data;

        // Extract timezone and custom fields
        const {
          timezone,
          location_custom_1_alias,
          location_custom_1_enabled,
          location_custom_1_required,
          location_custom_2_alias,
          location_custom_2_enabled,
          location_custom_2_required,
          location_custom_3_alias,
          location_custom_3_enabled,
          location_custom_3_required,
          location_custom_4_alias,
          location_custom_4_enabled,
          location_custom_4_required,
          location_custom_5_alias,
          location_custom_5_enabled,
          location_custom_5_required,
          location_custom_6_alias,
          location_custom_6_enabled,
          location_custom_6_required,
          location_custom_7_alias,
          location_custom_7_enabled,
          location_custom_7_required,
          location_custom_8_alias,
          location_custom_8_enabled,
          location_custom_8_required,
        } = spaceData;
        const customFields = {
          location_custom_1_alias,
          location_custom_1_enabled,
          location_custom_1_required,
          location_custom_2_alias,
          location_custom_2_enabled,
          location_custom_2_required,
          location_custom_3_alias,
          location_custom_3_enabled,
          location_custom_3_required,
          location_custom_4_alias,
          location_custom_4_enabled,
          location_custom_4_required,
          location_custom_5_alias,
          location_custom_5_enabled,
          location_custom_5_required,
          location_custom_6_alias,
          location_custom_6_enabled,
          location_custom_6_required,
          location_custom_7_alias,
          location_custom_7_enabled,
          location_custom_7_required,
          location_custom_8_alias,
          location_custom_8_enabled,
          location_custom_8_required,
        };
        console.log(customFields)

        resolve({ timezone, customFields });
      })
      .catch((error) => {
        console.error("Failed to fetch space data", error);
        reject(error);
      });
  });
}


},
};
</script>
<style lang="scss" scoped>
.window-title {
  span {
    font-size: 13px;
  }
}

.add-device-btn {
  width: 120px;
}

.bottom-navigation-edit {
  position: absolute !important;
  bottom: 0 !important;
  left: 0;
  right: 0;
  margin: 0;
  box-shadow: 0 -4px 25px 0 rgba(0, 0, 0, 0.13);
}

::v-deep {
  .theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: var(--v-babyBlueish-base) !important;
    color: white !important;
  }
}
</style>